<div class="infographics py-v-spacing">
  <div class="max-w-vision mx-auto px-4">
    @if (isResponsiveMode) {
      <picture class="block w-full">
        <source media="(min-width: 1440px)" [srcset]="infographicImages.xl" />
        <source media="(min-width: 1024px)" [srcset]="infographicImages.lg" />
        <source media="(min-width: 768px)" [srcset]="infographicImages.md" />
        <source media="(min-width: 600px)" [srcset]="infographicImages.sm" />
        <img
          [src]="infographicImages.xs"
          [alt]="responsiveAltText"
          [attr.aria-describedby]="hasDescription ? 'infographic-desc' : null"
          class="w-full max-w-[414px] mx-auto"
          loading="lazy"
        />
      </picture>
    }

    @if (hasDescription) {
      <div class="infographics__details mt-4">
        <button
          class="infographics__summary flex flex-row items-center gap-3 h-[30px] w-full cursor-pointer"
          (click)="toggle()"
          [attr.aria-expanded]="isOpen"
          aria-controls="infographic-desc"
        >
          <span class="flex-1 text-left font-body font-bold text-sm leading-7">Text version of this infographic</span>
          <span [class.hidden]="isOpen" [innerHTML]="openIcon"></span>
          <span [class.hidden]="!isOpen" [innerHTML]="closeIcon"></span>
        </button>
        <div id="infographic-desc" class="infographics__description wysiwyg wysiwyg-content" [class.hidden]="!isOpen" [innerHTML]="data.longDescription"></div>
      </div>
    }
  </div>
</div>
